// extracted by mini-css-extract-plugin
export default {"sitesProperties":"SitesToMigrate_sitesProperties__Di1en"};